<script>
export default {
  name: 'SplashScreen',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    styles () {
      return {
        splash: {
          '--opacity': this.visible ? 1 : 0,
          '--blur': this.visible ? '10px' : '0px'
        }
      }
    }
  }
}
</script>

<template>
  <div
    class="splash-screen"
    :style="styles.splash"
  >
    <div class="spinner" />
  </div>
</template>

<style lang="scss" scoped>
.splash-screen {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  backdrop-filter: blur(var(--blur));
  transition: backdrop-filter 500ms linear;
  pointer-events: none;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: '';
    opacity: var(--opacity);
    transition: opacity 500ms linear;
    background-color: black;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .spinner{
    opacity: var(--opacity);
    transition: opacity 500ms linear;
    width: 60px;
    height: 60px;
    border-top: 3px solid rgba(255, 255, 255, 00.95);
    border-right: 3px solid transparent;
    border-radius: 50%;
    animation: rotation .8s linear infinite;
  }
}

@keyframes rotation{
  from{
    transform: rotate(0deg);
  }
  to{
    transform: rotate(360deg);
  }
}
</style>
